
/* eslint-disable react/jsx-pascal-case */
import moment from 'moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import count_days from '../../functions/count_days';
import date_minus_day from '../../functions/date_minus_day';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import '../../Helper/links';
import { _endPoints, getapartment_dates_resort } from '../../Helper/links';
import API from '../../Helper/server/API';
import BookingCustomerStep from '../addition/BookingCustomerStep';
import { BookingProvider } from '../BookingContext';
import BookingEditConfirmStep from './BookingEditConfirmStep';

function BookingEdit() {
  const toast = useRef(null);
  const Navigate = useNavigate();
  let booking_apartment_dates = {};
  const { state } = useLocation();
  const items = Array.from({ length: 5 }, (v, i) => i);
  const [loading_render, set_loading_render] = useState(true);
  const [bookingApartmentData, setbookingApartmentData] = useState(state?.reservation);
  const [bookingCustomerData, setbookingCustomerData] = useState(state?.customer);
  const handleCustomertData = (data) => {
    setbookingCustomerData(data)
  };
  //__________________________________________________________________________________________________________________
  const [apartment, setApartment] = useState({ "dates_reservationes": [] });
  function dates_close(dates_reservationes, not_date_check_in, not_date_check_out) {
    var dates_disabled = [];
    if (dates_reservationes?.length >= 1) {
      // eslint-disable-next-line array-callback-return
      dates_reservationes?.map((date) => {
        var date_in = new Date(date.date_check_in);
        var date_out = new Date(date.date_check_out);
        if (
          moment(date_in).format("yyyy-MM-DD") !== moment(not_date_check_in).format("yyyy-MM-DD")
          &&
          moment(date_out).format("yyyy-MM-DD") !== moment(not_date_check_out).format("yyyy-MM-DD")
        ) {
          while (moment(date_in).format("yyyy-MM-DD") < moment(date_out).format("yyyy-MM-DD")) {
            dates_disabled.push(new Date(moment(date_in).format("yyyy-MM-DD")));
            date_in.setDate(date_in.getDate() + 1);
          }
        }
      })
      return dates_disabled;
    }
    else {
      return [];
    }
  }
  function dateTemplate(date, dates_reservationes, not_date_check_in, not_date_check_out) {
    var day_test = new Date(date.year + "-" + (date.month + 1) + "-" + date.day);
    for (var i = 0; i < dates_reservationes?.length; i++) {
      if (
        moment(day_test).format("yyyy-MM-DD") >= moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
        &&
        moment(day_test).format("yyyy-MM-DD") < moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
        &&
        moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD") !== moment(not_date_check_in).format("yyyy-MM-DD")
        &&
        moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD") !== moment(not_date_check_out).format("yyyy-MM-DD")
      ) {
        return (
          <strong style={{ textDecoration: 'line-through', color: "red" }}>{date.day}</strong>
        );
      }

    }
    return (
      <strong style={{ color: "black" }}>{date.day}</strong>
    );
  }
  const [dates, setDates] = useState([new Date(bookingApartmentData?.date_check_in), date_minus_day(new Date(bookingApartmentData?.date_check_out), 1)]);
  const handelDates = (e, dates_reservationes, id_apartment, not_date_check_in, not_date_check_out) => {
    var days = null;
    var date_is_empty = true;
    if (!e.target.value) {
      setDates([]);
      // document.getElementById("ldates").style.color="red"
    }
    else if (e.target.value && e.target?.value?.length > 0 && moment(e.target.value[0]).format('yyyy-MM-DD') >= moment(new Date()).format('yyyy-MM-DD')) {
      for (var i = 0; i < dates_reservationes?.length; i++) {
        if (
          (
            (
              moment(e.target.value[0]).format("yyyy-MM-DD") >= moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
              &&
              moment(e.target.value[0]).format("yyyy-MM-DD") < moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
              &&
              e.target.value[0] && e.target.value[0] !== null
            )
            ||
            (
              moment(e.target.value[1]).format("yyyy-MM-DD") >= moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
              &&
              moment(e.target.value[1]).format("yyyy-MM-DD") < moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
              &&
              e.target.value[1] && e.target.value[1] !== null
            )
            ||
            (
              moment(e.target.value[0]).format("yyyy-MM-DD") <= moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
              &&
              moment(e.target.value[1]).format("yyyy-MM-DD") >= moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
              &&
              e.target.value[1] && e.target.value[1] !== null
            )
          )
          &&
          moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD") !== moment(not_date_check_in).format("yyyy-MM-DD")
          &&
          moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD") !== moment(not_date_check_out).format("yyyy-MM-DD")
        ) {
          date_is_empty = false;
          break;
        }
      }
      if (date_is_empty) {
        setDates(e.target.value);
        // setdiscount_value(0)
        booking_apartment_dates[id_apartment] = e.target.value;
        if (!e.target.value[1]) {
          days = count_days([{ "date_check_in": e.target.value[0], "date_check_out": new Date(new Date(e.target.value[0]).setDate(e.target.value[0].getDate() + 1)) }]);
          setbookingApartmentData({
            ...bookingApartmentData,
            date_check_in: moment(e.target.value[0]).format("YYYY-MM-DD"),
            date_check_out: moment(new Date(new Date(e.target.value[0]).setDate(e.target.value[0].getDate() + 1))).format("YYYY-MM-DD"),
            total_price: (bookingApartmentData.price_day * days),
            discount_value: 0
          })
        }
        else {
          days = count_days([{ "date_check_in": e.target.value[0], "date_check_out": new Date(new Date(e.target.value[1]).setDate(e.target.value[1].getDate() + 1)) }]);
          setbookingApartmentData({
            ...bookingApartmentData,
            date_check_in: moment(e.target.value[0]).format("YYYY-MM-DD"),
            date_check_out: moment(new Date(new Date(e.target.value[1]).setDate(e.target.value[1].getDate() + 1))).format("YYYY-MM-DD"),
            total_price: (bookingApartmentData.price_day * days),
            discount_value: 0
          })
        }
      }
    }
  }
  const GetApartment = async (id_apartment) => {
    set_loading_render(true)
    const response = await API.get(`${getapartment_dates_resort}?ID_apartment=${id_apartment}`)
    if (response?.success === 1) {
      setApartment(response?.data);
      booking_apartment_dates[apartment.ID_apartment] = [new Date(bookingApartmentData.date_check_in), new Date(bookingApartmentData.date_check_out)];
      set_loading_render(false)
    }
    else if (response?.success === 0 || response?.errors == 1) {
      toast?.current?.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'error', summary: 'خطــاء', detail: response?.msg
      });
    }

  }
  useEffect(() => {
    if (!state || !state.reservation || !state.customer || !bookingApartmentData?.ID_apartment) {
      Navigate('/bookings')
    }
    GetApartment(bookingApartmentData?.ID_apartment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="page-wrapper" dir="rtl"   >
      <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
      <div className="content-wrapper">

        <div className="page-heading">
          <h1 className="page-title"> تعديــل حجــوزات </h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="index.html"><i className="la la-home font-20"></i></a>
            </li>
          </ol>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="ibox">
              <BookingProvider>
                <Stepper style={{ flexBasis: '50rem', fontFamily: "Cairo" }} headerPosition="bottom">
                  <StepperPanel activeIndex='var(--primary-color)' header={<p>نــوع الإقـــامة</p>} icon="pi pi-user" style={{ margin: "0", padding: "0", width: "100%" }}>
                    {
                      loading_render ?
                        <div className="border-round border-1 surface-border surface-card">
                          <div className="row">
                            <div className="col-md-4" >
                              <div className="card" style={{ width: "100%" }}>
                                <Skeleton width="100%" height="350px"  ></Skeleton>
                                <DataTable value={items} className="p-datatable-striped">
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                </DataTable>
                              </div>
                            </div>
                            <div className="col-md-4" >
                              <div className="card" style={{ width: "100%" }}>
                                <Skeleton width="100%" height="350px" ></Skeleton>
                                <DataTable value={items} className="p-datatable-striped">
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                </DataTable>
                              </div>
                            </div>
                            <div className="col-md-4" >
                              <div className="card" style={{ width: "100%" }}>
                                <Skeleton width="100%" height="350px" ></Skeleton>
                                <DataTable value={items} className="p-datatable-striped">
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                  <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                </DataTable>
                              </div>
                            </div>
                          </div>
                        </div>
                        :
                        <div className="row">
                          <div className="col-md-12" >
                            <div className="col-md-4">
                              <Slide >
                                {
                                  apartment?.images?.length > 0 ?
                                    (
                                      apartment?.images?.map((image, key) => {
                                        return (
                                          <a data-fancybox={`${apartment.name}-${apartment.number}`} href={_endPoints.apartments.images + image} alt={`${apartment.name}-${key}`} >
                                            <img src={_endPoints.apartments.images + image} alt={image} style={{ width: "100%", height: "350px", objectFit: "cover" }} onError={(e) => (e.target.src = _endPoints.apartments.images + `apartment.png`)} key={key} />
                                          </a>
                                        )
                                      })
                                    )
                                    :
                                    (
                                      <>
                                        <div className="each-slide-effect">
                                          <div style={{ 'backgroundImage': `url(${_endPoints.apartments.images + "apartment.png"})`, width: "100%", height: "350px" }}>
                                            {/* <span>Slide 1</span> */}
                                          </div>
                                        </div>
                                      </>
                                    )
                                }
                              </Slide>
                              <table className="table table-bordered" style={{ marginBottom: "0px", marginTop: "0px" }}>
                                <tr>
                                  <th style={{ textAlign: "center" }}>
                                    <h6 >  {view_apartment_type_ar(bookingApartmentData.type) + '  ' + bookingApartmentData.number}  </h6>
                                  </th>
                                  <th style={{ textAlign: "center" }}>
                                    <h6 >   {bookingApartmentData.number_people} أشخاص  </h6>
                                  </th>
                                  <th style={{ textAlign: "center" }}>
                                    <h6 >  {bookingApartmentData.price_day + ' د.ل '} </h6>
                                  </th>
                                </tr>
                              </table>
                              {
                                apartment?.images?.length > 0 ?
                                  (
                                    apartment?.images?.map((image, key) => {
                                      return (
                                        <div className="column" style={{ display: "none" }} key={`div-column-${key}`}>
                                          <a data-fancybox={apartment.number} href={_endPoints.apartments.images + image}>
                                            <img className="img-circle" alt="logo" src={_endPoints.apartments.images + image} width="50" height="50" />
                                          </a>
                                        </div>
                                      )
                                    })
                                  )
                                  :
                                  (null)
                              }
                              <Calendar
                                inputId="dates"
                                nextIcon={<i className="fa fa-angle-left" style={{ fontSize: "2rem" }}></i>}
                                prevIcon={<i className="fa fa-angle-right" style={{ fontSize: "2rem" }}></i>}
                                minDate={new Date()}
                                maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                dateTemplate={(e) => dateTemplate(e, apartment?.dates_reservationes, state?.reservation?.date_check_in, state?.reservation?.date_check_out)}
                                disabledDates={dates_close(apartment?.dates_reservationes, state?.reservation?.date_check_in, state?.reservation?.date_check_out)}
                                value={dates}
                                onChange={(e) => handelDates(e, apartment?.dates_reservationes, bookingApartmentData.ID_apartment, state?.reservation?.date_check_in, state?.reservation?.date_check_out)}
                                selectionMode="range"
                                readOnlyInput
                                inline
                                locale="ar" dir="rtl"
                                disabled={moment(bookingApartmentData.date_check_in).format('yyyy-MM-DD') >= moment(new Date()).format('yyyy-MM-DD') ? false : true}
                                style={{ width: "100%", fontFamily: "Cairo", padding: "0px" }} panelStyle={{ fontFamily: "Cairo" }}
                                dateFormat="yy-mm-dd"
                                footerTemplate={() => {
                                  return (
                                    <>
                                      <table className="table table-bordered" style={{ margin: "0px", padding: "0px" }}>
                                        <tr>
                                          <th style={{ textAlign: "center", verticalAlign: "middle", width: "40%" }}>
                                            <h6 >
                                              {
                                                bookingApartmentData.date_check_in && bookingApartmentData.date_check_out ?
                                                  (<>
                                                    عدد الأيـام  {count_days([bookingApartmentData])}
                                                  </>

                                                  )
                                                  :
                                                  (
                                                    <>
                                                      عدد الأيـام -
                                                    </>
                                                  )
                                              }
                                            </h6>
                                          </th>
                                          <th style={{ textAlign: "center", verticalAlign: "middle", width: "40%" }} >
                                            <h6>
                                              {
                                                bookingApartmentData.date_check_in && bookingApartmentData.date_check_out ?
                                                  (<>
                                                    السعــر {bookingApartmentData.price_day * count_days([bookingApartmentData])}  د،ل
                                                  </>

                                                  )
                                                  :
                                                  (
                                                    <>
                                                      السعــر  {bookingApartmentData.price_day ? bookingApartmentData.price_day * 0 : 0}  د،ل
                                                    </>
                                                  )
                                              }
                                            </h6>
                                          </th>
                                          <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "15px" }}>
                                            <Button text severity="secondary" icon="fa fa-close" className="pl-4 pr-4" style={{ fontFamily: "Cairo", width: "100%", height: "100%" }} onClick={() => {
                                              setDates([])
                                            }} />
                                          </th>
                                        </tr>
                                      </table>
                                    </>
                                  )
                                }}
                              />
                            </div>
                          </div>
                        </div>
                    }
                  </StepperPanel>

                  <StepperPanel header={<p>العميـــل</p>}>
                    <BookingCustomerStep onDataChange={handleCustomertData} bookingCustomerData={bookingCustomerData} />
                  </StepperPanel>

                  <StepperPanel header={<p>تعديــل الحجــز</p>}>
                    <BookingEditConfirmStep bookingData={bookingApartmentData} setbookingApartmentData={setbookingApartmentData} bookingCustomerData={bookingCustomerData} setbookingCustomerData={setbookingCustomerData}></BookingEditConfirmStep>
                  </StepperPanel>
                </Stepper>
              </BookingProvider>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BookingEdit

